export const TRACKING_CONSENT_COOKIE = 'daysheetly_tracking_consent';
export const TRACKING_CONSENT_EVENT = 'daysheetly:tracking-consent-changed';

export type TrackingConsent = 'granted' | 'denied' | null;

function readCookie(): TrackingConsent {
  if (typeof document === 'undefined') return null;

  const cookie = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${TRACKING_CONSENT_COOKIE}=`));
  const value = cookie?.split('=')[1];
  return value === 'granted' || value === 'denied' ? value : null;
}

export function getTrackingConsent(): TrackingConsent {
  if (typeof window === 'undefined') return null;

  const cookieConsent = readCookie();
  if (cookieConsent) return cookieConsent;

  try {
    const stored = localStorage.getItem(TRACKING_CONSENT_COOKIE);
    return stored === 'granted' || stored === 'denied' ? stored : null;
  } catch {
    return null;
  }
}

export function setTrackingConsent(consent: Exclude<TrackingConsent, null>) {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(TRACKING_CONSENT_COOKIE, consent);
  } catch {
    // The shared cookie remains the source of truth across subdomains.
  }
  const isDaySheetlyHost = window.location.hostname === 'daysheetly.com'
    || window.location.hostname.endsWith('.daysheetly.com');
  const domain = isDaySheetlyHost ? '; Domain=.daysheetly.com' : '';
  document.cookie = `${TRACKING_CONSENT_COOKIE}=${consent}; Max-Age=31536000; Path=/; SameSite=Lax${domain}`;
  window.dispatchEvent(new CustomEvent(TRACKING_CONSENT_EVENT));
}

export function useTrackingConsent(): TrackingConsent {
  const [consent, setConsent] = useState<TrackingConsent>(null);

  useEffect(() => {
    const sync = () => setConsent(getTrackingConsent());
    sync();
    window.addEventListener(TRACKING_CONSENT_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(TRACKING_CONSENT_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return consent;
}
import { useEffect, useState } from 'react';
